import { AuditJobRequest, AuditWorkpaperResponse } from '../Models/Api/strongbox.financialportal';

import { FetchMethod, fetchWrapper } from '../Utils/FetchWrapper';

/**
 * Retrieves the set of audit workpapers that can be run.
 */
export async function GetAuditWorkpapers(): Promise<AuditWorkpaperResponse> {
    const url = `/api/Audit/workpapers`;

    const res = await fetchWrapper(
        url,
        {
            method: FetchMethod.Get,
        },
        true,
        true
    );

    if (!res.ok) {
        throw new Error(`GetAuditWorkpapers failed. status=${res.status} ${res.statusText}`);
    }

    return await res.json();
}

/**
 * Starts an audit job for the given parameters.
 */
export async function StartAuditJob(request: AuditJobRequest): Promise<void> {
    const url = `/api/Audit/auditjob`;

    const res = await fetchWrapper(
        url,
        {
            method: FetchMethod.Post,
            body: JSON.stringify(request),
        },
        true,
        true
    );

    if (!res.ok) {
        throw new Error(`StartAuditJob failed. status=${res.status} ${res.statusText}`);
    }
}
